module.exports = __webpack_public_path__ + "img/hex.3c1baa04.jpg";